// extracted by mini-css-extract-plugin
export default {"form":"CancelarServico_form__-VFaK","areaBtn":"CancelarServico_areaBtn__bmcF1","btn":"CancelarServico_btn__4DR1t","btn2":"CancelarServico_btn2__264ux"};